import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export default function IDGPushNotificationManager() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      console.log("Push notifications not supported in this browser.");
      return;
    }

    const initPush = async () => {
      try {
        // Request Permission
        let permission = Notification.permission;
        if (permission === "default") {
          permission = await Notification.requestPermission();
        }
        if (permission !== "granted") {
          console.log("Notification permission not granted.");
          return;
        }

        // Register Service Worker
        // Public dir files are served from /app/sw.js under the Passenger node app
        const registration = await navigator.serviceWorker.register("/app/sw.js", {
          scope: "/app/"
        });

        // Check if already subscribed
        let subscription = await registration.pushManager.getSubscription();
        
        if (!subscription) {
          // Fetch public key
          const { data } = await api.get("/idg/push/keys");
          const applicationServerKey = urlBase64ToUint8Array(data.publicKey);
          
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey
          });
        }

        // Send subscription to backend
        await api.post("/idg/push/subscribe", {
          subscription: subscription.toJSON()
        });
        console.log("Subscribed to push notifications successfully.");
      } catch (err) {
        console.error("Failed to setup push notifications:", err);
      }
    };

    initPush();
  }, [user]);

  return null;
}
